// extracted by mini-css-extract-plugin
export var closeButton = "video-player-module--closeButton--25b0c";
export var desktopmodalContent = "video-player-module--desktopmodalContent--78b8e";
export var fullscreenClose = "video-player-module--fullscreenClose--3db27";
export var fullscreenIframe = "video-player-module--fullscreenIframe--b9a2b";
export var fullscreenOverlay = "video-player-module--fullscreenOverlay--1517c";
export var fullscreenPlayer = "video-player-module--fullscreenPlayer--2da5b";
export var mobilemodalContent = "video-player-module--mobilemodalContent--bcc29";
export var modalContent = "video-player-module--modalContent--8a3d4";
export var modalPlayerWrapper = "video-player-module--modalPlayerWrapper--a1b0b";
export var playArrow = "video-player-module--playArrow--3fc2f";
export var wrapper = "video-player-module--wrapper--f6560";